/* ==========================================================================
   Supplement buy box controller — Jagger & Lewis
   - Weight selector -> updates the informational daily-dose line (no price effect)
   - Flavour / Format radios drive the NATIVE xo-product variant + price morph
   - Plan toggle writes the native hidden input[name="selling_plan"]
   - Live total recomputed from a self-contained variants JSON (no dependency
     on product-data.liquid, which ships an invalid trailing comma)
   ========================================================================== */
(function () {
  'use strict';

  function num(v, d) {
    var n = parseFloat(String(v == null ? '' : v).replace(',', '.'));
    return isNaN(n) ? (d || 0) : n;
  }

  function money(cents) {
    return (cents / 100)
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
  }

  function initBuyBox(root) {
    if (root.dataset.sbbReady) return;
    root.dataset.sbbReady = '1';

    var variants = [];
    try {
      var dataEl = root.querySelector('[data-sbb-variants]');
      variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    } catch (e) { variants = []; }

    var atcText = root.dataset.sbbAtcText || 'Ajouter au panier';
    var atcShowPrice = root.dataset.sbbAtcPrice === '1';
    var subPct = num(root.dataset.sbbSubPct, 10);
    var sellingPlanInput = root.querySelector('[data-sbb-selling-plan]');
    var klarnaEl = root.querySelector('.sbb__klarna');

    /* ---- Custom frequency dropdown (no native <select>) — aggregates plans across ALL groups ---- */
    var freqWrap = root.querySelector('[data-sbb-freq]');
    var freqBox = root.querySelector('[data-sbb-freq-select]');
    var freqToggle = root.querySelector('[data-sbb-freq-toggle]');
    var freqListEl = root.querySelector('[data-sbb-freq-list]');
    var freqCurrent = root.querySelector('[data-sbb-freq-current]');
    var freqOpts = freqListEl ? Array.prototype.slice.call(freqListEl.querySelectorAll('.sbb__freq-opt')) : [];
    var selectedFreq = '';
    function freqMonths(t) { var m = String(t).match(/(\d+)\s*mois/i); if (m) return parseInt(m[1], 10); return /mois/i.test(t) ? 1 : 99; }
    function setFreq(opt) {
      if (!opt) return;
      selectedFreq = opt.getAttribute('data-value') || '';
      if (freqCurrent) freqCurrent.textContent = opt.textContent;
      freqOpts.forEach(function (o) { o.classList.toggle('is-selected', o === opt); });
    }
    function openFreq(open) {
      if (!freqBox || !freqListEl) return;
      freqBox.classList.toggle('is-open', open);
      freqListEl.hidden = !open;
      if (freqToggle) freqToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (freqOpts.length) {
      freqOpts.sort(function (a, b) { return freqMonths(a.textContent) - freqMonths(b.textContent); });
      freqOpts.forEach(function (o) { freqListEl.appendChild(o); }); /* tri 1/2/3 mois */
      setFreq(freqOpts[0]); /* mensuel par défaut */
      freqOpts.forEach(function (o) { o.addEventListener('click', function () { setFreq(o); openFreq(false); applyPlan(); }); });
      if (freqToggle) freqToggle.addEventListener('click', function (e) { e.preventDefault(); openFreq(freqListEl.hidden); });
      document.addEventListener('click', function (e) { if (freqWrap && !freqWrap.contains(e.target)) openFreq(false); });
    }

    /* ---- Weight -> dosage + pot autonomy (informational only) ---- */
    var dosageEl = root.querySelector('[data-sbb-dosage]');
    var dosageTpl = dosageEl ? (dosageEl.dataset.tpl || 'Quantité : [doses] dose(s) par jour') : '';
    var dosesPerPot = dosageEl ? num(dosageEl.dataset.dosesPerPot, 0) : 0;
    function fmtDose(d) {
      var s = String(d).replace(',', '.');
      if (s === '0.5') return '½';
      if (s === '1.5') return '1½';
      if (s === '2.5') return '2½';
      return d;
    }
    function renderDosage(doses) {
      return dosageTpl.replace('[doses]', '<strong>' + fmtDose(doses) + '</strong>');
    }
    /* Pot duration depends on doses_per_pot AND the daily dose (driven by dog weight).
       When doses_per_pot is set, recompute each quantity card's duration dynamically. */
    function formatDuration(days) {
      if (days < 14) return 'environ ' + Math.max(1, days) + ' jours';
      if (days < 60) return 'environ ' + Math.round(days / 7) + ' semaines';
      return 'environ ' + Math.round(days / 30) + ' mois';
    }
    function updateDurations(perDay) {
      if (!dosesPerPot) return; /* keep the fixed server-rendered durations */
      var d = num(perDay, 1); if (d <= 0) d = 1;
      var daysPerPot = dosesPerPot / d;
      root.querySelectorAll('[data-sbb-qty]').forEach(function (b) {
        var n = parseInt(b.dataset.sbbQty, 10) || 1;
        var el = b.querySelector('.sbb__qty-duration');
        if (el) el.textContent = formatDuration(Math.round(n * daysPerPot));
      });
      /* Multipack variant cards carry the duration directly (data-pots) */
      root.querySelectorAll('[data-sbb-duration][data-pots]').forEach(function (el) {
        var n = parseInt(el.dataset.pots, 10) || 1;
        el.textContent = formatDuration(Math.round(n * daysPerPot));
      });
    }
    root.querySelectorAll('[data-sbb-weight]').forEach(function (card) {
      card.addEventListener('click', function () {
        root.querySelectorAll('[data-sbb-weight]').forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
        if (dosageEl) dosageEl.innerHTML = renderDosage(card.dataset.doses || '');
        updateDurations(card.dataset.doses);
      });
    });
    var initWeight = root.querySelector('[data-sbb-weight].is-selected') || root.querySelector('[data-sbb-weight]');
    if (initWeight && dosageEl) { dosageEl.innerHTML = renderDosage(initWeight.dataset.doses || ''); }
    if (initWeight) updateDurations(initWeight.dataset.doses);

    /* ---- Option cards selected-state mirroring (price handled natively) ---- */
    function mirror(selector, selectedClass) {
      root.querySelectorAll(selector).forEach(function (card) {
        var input = card.querySelector('input[type="radio"]');
        if (!input) return;
        input.addEventListener('change', function () {
          root.querySelectorAll(selector).forEach(function (c) { c.classList.remove(selectedClass); });
          card.classList.add(selectedClass);
          refreshPrices();
        });
      });
    }
    mirror('.sbb__format-card', 'is-selected');
    mirror('.sbb__pill', 'is-selected');

    /* ---- "See more options" expander(s) ---- */
    root.querySelectorAll('[data-sbb-see-more]').forEach(function (seeMore) {
      var moreText = seeMore.textContent;
      var lessText = '− Voir moins d\'options';
      seeMore.setAttribute('aria-expanded', 'false');
      seeMore.addEventListener('click', function () {
        var scope = seeMore.closest('fieldset') || root;
        var willExpand = seeMore.getAttribute('aria-expanded') !== 'true';
        scope.querySelectorAll('[data-extra]').forEach(function (el) { el.hidden = !willExpand; });
        seeMore.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
        seeMore.textContent = willExpand ? lessText : moreText;
      });
    });

    /* ---- Quantity-degressive pots selector (1 variant + auto discount) ---- */
    var qtyButtons = root.querySelectorAll('[data-sbb-qty]');
    var quantityInput = root.querySelector('.sbb__atc input[name="quantity"]');
    var qtyTotal = null; /* discounted total (cents) for the chosen pot count */
    function applyQty(btn) {
      qtyButtons.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
      var n = parseInt(btn.dataset.sbbQty, 10) || 1;
      qtyTotal = parseInt(btn.dataset.qtyTotal, 10);
      if (quantityInput) quantityInput.value = n;
      refreshPrices();
    }
    qtyButtons.forEach(function (b) { b.addEventListener('click', function () { applyQty(b); }); });
    var initQty = root.querySelector('[data-sbb-qty].is-selected') || qtyButtons[0];
    if (initQty) qtyTotal = parseInt(initQty.dataset.qtyTotal, 10);

    /* ---- Plan toggle -> selling_plan hidden input + price display ---- */
    var planCards = root.querySelectorAll('[data-sbb-plan]');
    function applyPlan() {
      var checked = root.querySelector('input[name="sbb_plan"]:checked');
      var isSub = !!checked && checked.value === 'subscribe';
      planCards.forEach(function (c) {
        var on = c.dataset.sbbPlan === (isSub ? 'subscribe' : 'onetime');
        c.classList.toggle('is-selected', on);
      });
      if (freqWrap) freqWrap.hidden = !isSub;            /* la fréquence n'apparaît qu'en abonnement */
      if (klarnaEl) klarnaEl.style.display = isSub ? 'none' : ''; /* Klarna caché en abonnement */
      if (sellingPlanInput) {
        var subCard = root.querySelector('[data-sbb-plan="subscribe"]');
        var planId = selectedFreq || (subCard ? subCard.dataset.sellingPlanId : '');
        sellingPlanInput.value = isSub ? (planId || '') : '';
      }
      refreshPrices();
    }
    planCards.forEach(function (c) {
      var input = c.querySelector('input[name="sbb_plan"]');
      if (input) input.addEventListener('change', applyPlan);
    });

    /* ---- Current variant resolution (from self-contained JSON) ---- */
    function currentVariant() {
      if (!variants.length) return null;
      var selected = [];
      root.querySelectorAll('xo-product-variants input[type="radio"]:checked, xo-product-variants input[type="hidden"]').forEach(function (i) {
        if (i.value) selected.push(i.value);
      });
      if (!selected.length) return variants[0];
      var found = variants.filter(function (v) {
        return selected.every(function (s) { return (v.options || []).indexOf(s) > -1; });
      });
      return found[0] || variants[0];
    }

    /* ---- Price recompute (single source of truth) ---- */
    var atcBtnTextEl = null;
    function refreshPrices() {
      var v = currentVariant();
      if (!v) return;
      /* Two layouts share this controller:
         - Multipack VARIANTS (format path): the degressive price is baked into the variant,
           qtyTotal stays null -> baseTotal = variant price; sub = variant x (1-sub%). Stripe
           applies its flat -sub% coupon on the variant price at checkout AND every renewal.
         - Legacy QUANTITY selector (single variant): qtyTotal carries the tier total. */
      var qty = quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1;
      var fullTotal = v.price * qty;
      var baseTotal = (qtyTotal != null) ? qtyTotal : v.price;
      var compareAt = v.compare_at || 0;  // struck full price (multipack), 0 when none
      var isSub = (root.querySelector('input[name="sbb_plan"]:checked') || {}).value === 'subscribe';
      var subTotal = Math.round(baseTotal * (1 - subPct / 100));

      setText('[data-sbb-plan-price="onetime"]', money(baseTotal));
      setText('[data-sbb-plan-price="subscribe"]', money(subTotal));
      setText('[data-sbb-plan-strike]', money(baseTotal)); /* abo card strikes the one-time price */

      var total = isSub ? subTotal : baseTotal;
      /* Strike reference on the ATC button. Subscription -> the one-time price;
         one-time -> compare_at (multipack) or the undiscounted qty total (legacy). */
      var fullRef;
      if (isSub) { fullRef = baseTotal; }
      else if (qtyTotal != null) { fullRef = fullTotal; }
      else { fullRef = compareAt; }
      setText('[data-sbb-atc-total]', money(total));
      if (atcShowPrice) {
        atcBtnTextEl = root.querySelector('.sbb__atc .xo-btn__text');
        if (atcBtnTextEl) {
          if (fullRef > total) {
            atcBtnTextEl.innerHTML = atcText + ' — <del class="sbb__atc-old">' + money(fullRef) + '</del> ' + money(total);
          } else {
            atcBtnTextEl.textContent = atcText + ' — ' + money(total);
          }
        }
      }
    }
    function setText(sel, txt) {
      root.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; });
    }

    root.querySelectorAll('xo-product-variants input[type="radio"]').forEach(function (i) {
      i.addEventListener('change', refreshPrices);
    });

    /* The native variant->morph replaces the add-button region and would wipe
       our price suffix. Re-apply after each morph. */
    var addRegion = root.querySelector('.sbb__atc xo-product-will-change');
    if (addRegion && atcShowPrice && 'MutationObserver' in window) {
      var raf = false;
      new MutationObserver(function () {
        if (raf) return;
        raf = true;
        requestAnimationFrame(function () { raf = false; refreshPrices(); });
      }).observe(addRegion, { childList: true, subtree: true });
    }

    applyPlan();
    refreshPrices();
  }

  function boot() {
    document.querySelectorAll('[data-sbb]').forEach(initBuyBox);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
